import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireAndroidDevelopers,
  HireAndroidProjects,
  HireAndroidHours,
  HireAndroidFasterTime,
} from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Ratingusa = () => {
  return (
    <div className="rating_usa rating_web_dev rating_hire_ios rating_hire_and tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="text-center mb-3 mb-md-4"
          >
            <h2>Trusted Android Talent at Your Fingertips</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">
                {/* <StaticImage
                  src="../../images/locationgcc/dubai_new/app_dev_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={95}
                /> */}
                {HireAndroidDevelopers}
              </div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  50+
                </div>
                <p style={{ color: "#fff" }}>Professional Developers</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">
                {/* <StaticImage
                  src="../../images/locationgcc/dubai_new/live_apps_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={96}
                /> */}
                {HireAndroidProjects}
              </div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  100+
                </div>
                <p style={{ color: "#fff" }}>Completed Projects</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="rating_box">
              <div className="rating-svg">
                {/* <StaticImage
                  src="../../images/services-usa/hire-ios-app-developers/clock.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={96}
                /> */}
                {HireAndroidHours}
              </div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  48
                </div>
                <p style={{ color: "#fff" }}>Hour Developer Onboarding</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="rating_box ps-xl-5">
              <div className="rating-svg">
                {/* <StaticImage
                  src="../../images/services-usa/hire-ios-app-developers/building.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={96}
                /> */}
                {HireAndroidFasterTime}
              </div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  80%
                </div>
                <p style={{ color: "#fff" }}>Faster Time-to-Market</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ratingusa;
